const BOXES = [0, 1, 2]

/* The three stakes a box carries. They are independent of one another: any of them may
   stand alone, and what one does has no bearing on the other two. */
const BET = "bet"
const DOUBLE = "double"
const SUPER = "super"

const BET_TYPES = [BET, DOUBLE, SUPER]

/* The order the three spots are printed in, top to bottom */
const SPOTS = [SUPER, DOUBLE, BET]

/* What each spot is called on the cloth, spelled the way it is printed there.

   The cloth alternates: the outer two boxes carry the English names, the middle one the
   Chinese. Same three stakes either way — only the printing differs. */
const BET_NAMES = {
    [BET]: "Normal bet",
    [DOUBLE]: "Double bet",
    [SUPER]: "Super Double"
}

const BET_NAMES_CN = {
    [BET]: "平倍",
    [DOUBLE]: "翻倍",
    [SUPER]: "超级翻倍"
}

/* Short labels for the places where the full name will not fit */
const BET_SHORT = {
    [BET]: "BET",
    [DOUBLE]: "DOUBLE",
    [SUPER]: "SUPER"
}

/* WHAT ONE UNIT OF EACH STAKE CAN COST AT WORST — what is held while it stands

   A loss in this game can run above the face of the stake, so the worst of it is taken off
   the player when the stake goes down and whatever the round does not take comes straight
   back at the end. These are the three figures the rules page gives the player in so many
   words: one on the Normal Bet, five on the Double Bet, fifteen on the Super Double.

   Two of the three ride above their face, not one. A stake is charged at its own cell of
   the paytable for the hand the dealer turned over, and only the Normal Bet is a flat one
   all the way down; the Double Bet runs to five against a four of a kind and the Super
   Double to fifteen. This copy read 1 for the Double Bet, which held less than the table
   can charge.

   Kept in step with config/payouts.js on the table side, where it is not written out at all
   but read off the paytable as the worst cell of each column — that is the authority, and
   this is only what the client holds a stake at while it is being placed. */
const MAX_LOSS = {
    [BET]: 1,
    [DOUBLE]: 5,
    [SUPER]: 15
}

/* WHETHER A LOSS ON THIS SPOT IS WORTH PUTTING A FIGURE ON

   A stake that can be charged above its face, and only that. The figure is the one place
   the player is told he lost more than he put down — the Super Double at up to fifteen
   times and the Double Bet at up to five — so it belongs on both of them.

   The Normal Bet is a flat one all the way down the table. Its figure could only ever read
   −1x, which says nothing the chips coming off the spot have not already said, so there is
   nothing to write there. */
const showsLoss = type => MAX_LOSS[type] > 1

/* One box as this player holds it. Nobody owns a box: all three are open to everyone. */
const createEmptyBox = () => ({
    [BET]: 0,
    [DOUBLE]: 0,
    [SUPER]: 0,
    result: null
})

const createEmptyBoxes = () => BOXES.map(() => createEmptyBox())

/* Is there anything at all on this box? */
const boxStaked = box => !!(box && BET_TYPES.some(type => box[type] > 0))

/* The face value of what is on one box — what the player thinks of as his stake */
const boxFace = box => box ? BET_TYPES.reduce((sum, type) => sum + (box[type] > 0 ? box[type] : 0), 0) : 0

/* What one box actually costs to hold — see MAX_LOSS */
const boxCost = box => box ? BET_TYPES.reduce((sum, type) => sum + ((box[type] > 0 ? box[type] : 0) * MAX_LOSS[type]), 0) : 0

/* What the whole slip costs */
const boxesCost = boxes => Array.isArray(boxes) ? boxes.reduce((sum, box) => sum + boxCost(box), 0) : 0

/* The face value of the whole slip */
const boxesFace = boxes => Array.isArray(boxes) ? boxes.reduce((sum, box) => sum + boxFace(box), 0) : 0

/* The boxes the player actually has money on */
const activeBoxes = boxes => Array.isArray(boxes) ? BOXES.filter(index => boxStaked(boxes[index])) : []

export {
    BOXES,
    BET,
    DOUBLE,
    SUPER,
    BET_TYPES,
    SPOTS,
    BET_NAMES,
    BET_NAMES_CN,
    BET_SHORT,
    MAX_LOSS,
    showsLoss,
    createEmptyBox,
    createEmptyBoxes,
    boxStaked,
    boxFace,
    boxCost,
    boxesCost,
    boxesFace,
    activeBoxes
}
